// extracted by mini-css-extract-plugin
export var container = "Artboard-module--container--JbhIr";
export var templateHandle = "Artboard-module--templateHandle--FqveE";